export const DOI_FORM = "7261075";

export const DOI_FIELDS = Object.freeze({
  DOI: "198744343",
} as const);

export type DoiFields = keyof typeof DOI_FIELDS;

export const DOI_FIELD_SET = new Set(
  (Object.keys(DOI_FIELDS) as DoiFields[]).map(
    (key: DoiFields) => DOI_FIELDS[key]
  )
);

export const DOI_REQUIRED_FIELDS = [DOI_FIELDS.DOI];
